import { combineReducers } from 'redux'
import ACTIONS from './types'
import omit from 'lodash/omit'
import concat from 'lodash/concat'
import without from 'lodash/without'
import omitBy from 'lodash/omitBy'
import isEmpty from 'lodash/isEmpty'
import flattenDeep from 'lodash/flattenDeep'
import _ from 'lodash'
import {
  removeItemArrayById,
  moveBeforeById,
  moveAfterById,
  addItemToArray,
  addMultipleItemsToArray,
} from 'helpers/arrayHelpers'


const addMultipleIdsToParentComponent = (parent, ids, addToIndex) => {
  return { ...parent, elements: addMultipleItemsToArray(parent.elements, ids, addToIndex)}
}

const addIdToParentComponent = (parent, childId, addToIndex) => {
  return { ...parent, elements: addItemToArray(parent.elements, childId, addToIndex)}
}

const removeIdFromParent = (parent, childId) => {
  return { ...parent, elements: removeItemArrayById(parent.elements, childId)}
}

const selectChildrenElementIdToRemove = (state, elementIdSelected) => {
  if (isEmpty(elementIdSelected)) {
    return null
  }
  return flattenDeep(concat([], elementIdSelected.map((elementId) => {
    if (state[elementId] && state[elementId].elements) {
      return concat([], elementId, selectChildrenElementIdToRemove(state,
        state[elementId].elements))
    }
    return elementId
  })))
}

const switchIdInParent = (parent, elementId, switchFunction) => {
  return {
    ...parent,
    elements: switchFunction(parent.elements, elementId)
  }
}

const addMultipleColumn = ({ columns, allElement, elementById }) => {
  const { defaultSettings: { computer }} = columns[0]
  const prevElement = _.slice(allElement, 0 , allElement.length - columns.length)
  const newPrevElement = prevElement.map((id) => {
    const element = elementById[id]
    return {
      ...element,
      defaultSettings: {
        ...element.defaultSettings,
        computer,
        tablet: computer,
        mobile: computer,
      }
    }
  })
  const newAllElement = concat(newPrevElement, columns)
  return _.keyBy(newAllElement, 'id')
}

const removeColumn = ({ columns, elementById }) => {
  const newElement = columns.map((id) => {
    const element = elementById[id]
    return {
      ...element,
      defaultSettings: {
        ...element.defaultSettings,
        computer: 12/columns.length,
        tablet: 12/columns.length,
        mobile: 12/columns.length,
      }
    }
  })
  return _.keyBy(newElement, 'id')
}

const elementById = (state = {}, action) => {
  const {
    element = {},
    parentId,
    addToIndex,
    columnById,
    elementId,
    details,
    elementById,
    newElements,
  } = action
  const { id } = element
  switch (action.type) {
    case ACTIONS.ADD_TEMPLATE_TO_ROOT:
      return {
        ...state,
        ...elementById,
      }
    case ACTIONS.ADD_TEMPLATE_TO_ELEMENT:
      return {
        ...state,
        [parentId]: addMultipleIdsToParentComponent(state[parentId], details, addToIndex),
        ...elementById,
      }
    case ACTIONS.CREATE_ELEMENT:
      return {
        ...state,
        [parentId]: addIdToParentComponent(state[parentId], id, addToIndex),
        [id]: element,
        ...columnById, // in case of columns
      }
    case ACTIONS.CREATE_ROOT_ELEMENT:
      return {
        ...state,
        [id]: element,
        ...columnById, // in case of columns
      }
    case ACTIONS.DELETE_ROOT_ELEMENT:
      return omit(state, selectChildrenElementIdToRemove(state, [elementId]))
    case ACTIONS.DELETE_ELEMENT:
      return omit({
        ...state,
        [parentId]: removeIdFromParent(state[parentId], elementId),
      }, selectChildrenElementIdToRemove(state, [elementId]))
    case ACTIONS.UPDATE_ELEMENT:
      return { ...state, [element.id]: element }
    case ACTIONS.SWITCH_UP:
      return {
        ...state,
        [parentId]: switchIdInParent(state[parentId], elementId, moveBeforeById),
      }
    case ACTIONS.SWITCH_DOWN:
      return {
        ...state,
        [parentId]: switchIdInParent(state[parentId], elementId, moveAfterById),
      }
    case ACTIONS.INJECT_PAINT:
      return action.elementById || {}
    case ACTIONS.INITIALIZE_PAINT:
      return {}
    case ACTIONS.ADD_COLUMN:
      return {
        ...state,
        [element.id]: element,
        ...addMultipleColumn({ columns: newElements, allElement: element.elements , elementById: state }), // in case of columns
      }
    case ACTIONS.REMOVE_COLUMN:
      return {
        ...state,
        [element.id]: element,
        ...removeColumn({ columns: element.elements, elementById: state })
      }
    default:
      return state
  }
}

const details = (state = [], action) => {
  const { element = {}, addToIndex, elementId, details } = action
  const { id } = element
  switch (action.type) {
    case ACTIONS.ADD_TEMPLATE_TO_ROOT:
      return addMultipleItemsToArray(state, details, addToIndex)
    case ACTIONS.CREATE_ROOT_ELEMENT:
      return addItemToArray(state, id, addToIndex)
    case ACTIONS.DELETE_ROOT_ELEMENT:
      return without(state, elementId)
    case ACTIONS.SWITCH_ROOT_UP:
      return moveBeforeById(state, elementId)
    case ACTIONS.SWITCH_ROOT_DOWN:
      return moveAfterById(state, elementId)
    case ACTIONS.INJECT_PAINT:
      return action.details || []
    case ACTIONS.INITIALIZE_PAINT:
      return []
    default:
      return state
  }
}

const overElementId = (state = null, action) => {
  const { elementId } = action
  switch (action.type) {
    case ACTIONS.OVER_ELEMENT:
      return elementId
    default:
      return state
  }
}

const selectedId = (state = null, action) => {
  const { elementId } = action
  switch (action.type) {
    case ACTIONS.SELECT_ELEMENT:
      return elementId
    default:
      return state
  }
}

const elementSelector = (state = null, action) => {
  switch (action.type) {
    case ACTIONS.OPEN_ELEMENTS_SELECTOR:
      return action.selectorId
    case ACTIONS.CLOSE_ELEMENTS_SELECTORS:
    case ACTIONS.CREATE_ROOT_ELEMENT:
    case ACTIONS.CREATE_ELEMENT:
    case ACTIONS.ADD_TEMPLATE_TO_ROOT:
    case ACTIONS.ADD_TEMPLATE_TO_ELEMENT:
      return null
    default:
      return state
  }
}

const isElementChange = (state = [], action) => {
  switch (action.type) {
    case ACTIONS.CREATE_ROOT_ELEMENT:
    case ACTIONS.CREATE_ELEMENT:
    case ACTIONS.ADD_TEMPLATE_TO_ROOT:
    case ACTIONS.ADD_TEMPLATE_TO_ELEMENT:
    case ACTIONS.DELETE_ROOT_ELEMENT:
    case ACTIONS.DELETE_ELEMENT:
    case ACTIONS.UPDATE_ELEMENT:
    case ACTIONS.CHANGE_ELEMENT:
    case ACTIONS.DUPLICATE_ELEMENT:
    case ACTIONS.SWITCH_ROOT_DOWN:
    case ACTIONS.SWITCH_DOWN:
    case ACTIONS.SWITCH_ROOT_UP:
    case ACTIONS.SWITCH_UP:
      return true
    case ACTIONS.CLEAR_IS_ELEMENT_CHANGE:
    case ACTIONS.INJECT_PAINT:
    case ACTIONS.INITIALIZE_PAINT:
      return false
    default:
      return state
  }
}

export default combineReducers({
  details,
  elementById,
  selectedId,
  overElementId,
  elementSelector,
  isElementChange,
})



// WEBPACK FOOTER //
// ./src/store/canvas/reducer.js